<template>
  <div>
    <v-row>
      <v-col cols="12">
        <!-- <v-card-title>
          <v-row v-if="showEditActions">
            <v-col class="pl-0" cols="12" sm="12" md="12" lg="12">
              <v-btn color="success" class="mb-2" small @click="saveChanges(filteredItems, 'save')">Save Changes</v-btn>
              <v-btn color="warning" class="mb-2" small @click="resetEdit()">Cancel Edit</v-btn>
            </v-col>
          </v-row>
        </v-card-title> -->

        <!-- BEGIN vue data table -->
        <v-data-table 
        :headers="headers"
        :search="filter"
        :items="filteredItems" 
        class="elevation-1">
          <template v-slot:[`item.handle`]="{ item }">
            <div class="item-edit" v-if="item.handleEdit === false">
              <td class="text-left">
                <social-handle
                  :isInstagram="item.value === 'instagram'"
                  :isTikTok="item.value === 'tiktok'"
                  :isYoutube="item.value === 'youtube'"
                  :isXiaohongshu="item.value === 'xiaohongshu'"
                  :isFacebook="item.value === 'facebook'"
                  :isLinkedIn="item.value === 'linkedin'"
                  :isTwitter="item.value === 'twitter'"
                  :instagramHandle="item.handle"
                  :tiktokHandle="item.handle"
                  :youtubeHandle="item.handle"
                  :xiaohongshuHandle="item.handle"
                  :facebookHandle="item.handle"
                  :linkedinHandle="item.handle"
                  :twitterHandle="item.handle"
                  v-if="item.handle"
                  divClassName="float-left"
                />
                <v-icon 
                class="cursor-pointer pl-2"
                color="warning"
                x-small
                :disabled="item.connected"
                @click="openEditItem(item, 'handle', dataSourceName)">edit</v-icon>
              </td>
            </div>
            <div class="item-edit" v-else>
              <td>
                <v-text-field
                  class="input-field mt-3"
                  v-model="item.handle"
                  v-on="on"
                  dense
                  outlined
                ></v-text-field>
              </td>
            </div>
          </template>
          <template v-slot:[`item.action`]="{ item }">
            <td>
              <!-- Connected Button -->
              <v-btn disabled color="success" small v-if="item.connected">
                <v-icon color="white" small>mdi-account-check</v-icon> <span>Connected</span>
              </v-btn>
              <!-- Connect Button -->
              <v-btn @click="connectAction(item, 'connect')" color="success" small v-if="item.handle && !item.connected && !item.requested">
                <v-icon color="white" small>mdi-account-check</v-icon> <span>Connect</span>
              </v-btn>
              <!-- Disconnect Button -->
              <v-btn @click="connectAction(item, 'disconnect')" color="error" small v-if="item.connected" :disabled="filteredItems.filter(f => f.connected).length === 1">
                <v-icon color="white" small>mdi-account-remove</v-icon> Disconnect
              </v-btn>
              <!-- Approve Button (Same as Connect) -->
              <v-btn @click="connectAction(item, 'connect')" color="success" small v-if="item.handle && item.requested">
                <v-icon color="white" small>mdi-account-check</v-icon> <span>Approve</span>
              </v-btn>
              <!-- Reject Button (Same as Connect) -->
              <v-btn @click="rejectPlatform(item)" color="red" small v-if="item.handle && item.requested">
                <v-icon color="white" small>mdi-close</v-icon> <span>Reject</span>
              </v-btn>
            </td>
          </template>
          <template v-slot:no-data>No Data</template>
        </v-data-table>
      </v-col>
    </v-row>
    <loading
      :active.sync="isLoading"
      :can-cancel="false"
      :is-full-page="true"
      loader="bars"
      background-color="#000"
      color="secondary"
      width.number="180"
      height.number="180"
    />
  </div>
</template>
<script>
import { mapState } from 'vuex';
import SocialHandle from '@/components/scoped/custom/SocialHandle';
import DataTableMixin from '@/mixins/DataTableMixin'
import Loading from 'vue-loading-overlay';
import utils from '@/utils';
import config from '@/config';
export default {
  name: 'InfPlatformDataTable',
  mixins: [DataTableMixin],
  components: {
    SocialHandle,
    Loading
  },
  props: {
    value: Boolean,
    influencerID: String,
    items: Array
  },
  watch: {
    items(value) {
      this.refreshItems()
    }
  },
  data() {
    return {
      filter: '',
      filteredItems: [],
      dataSourceName: 'filteredItems',
      showEditActions: false,
      headers: [
        {
          text: 'Platform',
          value: 'text'
        },
        {
          text: 'Handle',
          value: 'handle'
        },
        {
          text: 'Actions',
          value: 'action'
        }
      ],
      isLoading: false
    }
  },
  computed: {
    ...mapState({
      saved: state => state.influencer.savedPlatforms,
      savedErr: state => state.influencer.savedPlatformsNotFoundErr,
      igInf: state => state.influencer.igInf,
      tiktokInf: state => state.influencer.tiktokInf,
      youtubeInf: state => state.influencer.youtubeInf,
      xhsInf: state => state.influencer.xhsInf,
      fbInf: state => state.influencer.fbInf,
      linkedinInf: state => state.influencer.linkedinInf,
      twitterInf: state => state.influencer.twitterInf
    })
  },
  mounted() {
    this.refreshItems()
  },
  methods: {
    async connectAction(item, type) {
      this.$swal({
        title: 'Double Check!',
        text: `Are you sure to ${type === 'connect' ? 'connect' : 'disconnect'}?`,
        confirmButtonText: 'Confirm',
        type: 'info',
        showCancelButton: true,
        showCloseButton: true
      }).then(async (result) => {
        if (result.value) {
          this.isLoading = true
          switch (type) {
            case 'connect':
              // check if inf already exists
              await this.checkInf(item.handle, item.value)
              if (this.igInf && this.igInf.influencerID) { // instagram
                this.$emit('showCompareModal', this.igInf)
                this.isLoading = false
              } else if (this.youtubeInf && this.youtubeInf.influencerID) { // youtube
                this.$emit('showCompareModal', this.youtubeInf)
                this.isLoading = false
              } else if (this.tiktokInf && this.tiktokInf.influencerID) { // tiktok
                this.$emit('showCompareModal', this.tiktokInf)
                this.isLoading = false
              } else if (this.xhsInf && this.xhsInf.influencerID) { // xhs
                this.$emit('showCompareModal', this.xhsInf)
                this.isLoading = false
              } else if (this.fbInf && this.fbInf.influencerID) { // facebook
                this.$emit('showCompareModal', this.fbInf)
                this.isLoading = false
              } else if (this.linkedinInf && this.linkedinInf.influencerID) { // linkedin
                this.$emit('showCompareModal', this.linkedinInf)
                this.isLoading = false
              } else if (this.twitterInf && this.twitterInf.influencerID) { // X
                this.$emit('showCompareModal', this.twitterInf)
                this.isLoading = false
              } else {
                this.saveChanges([item], 'connect')
              }
              break;
            case 'disconnect':
              this.disconnectInf([item])
              break;
          }
        }
      });
    },
    async saveChanges(items, source = 'save') {
      let data = this.buildFormData(items)
      await this.$store.dispatch('influencer/createMultiplePlatforms', { data })
      this.isLoading = false;
      if (this.saved) {
        // Show success message
        let msg = `Successfully ${source === 'connect' ? 'Connnected' : 'Updated'}`
        this.$swal({
          text: msg,
          type: 'success'
        });
        this.resetEdit()
        this.changeConnectState(items.length ? items[0] : {}, true)
        this.$emit('reload')
        return
      } else {
        if (this.savedErr) {
          this.$swal({
            text: 'Social Data Not Found!',
            type: 'error'
          });
        }
      }
    },
    async disconnectInf(items) {
      let data = this.buildFormData(items)
      await this.$store.dispatch('influencer/discountPlatforms', { data })
      this.isLoading = false;
      if (this.saved) {
        // Show success message
        let msg = `Successfully Disconnected`
        this.$swal({
          text: msg,
          type: 'success'
        });
        this.resetEdit()
        this.changeConnectState(items.length ? items[0] : {}, false)
        this.$emit('reload')
        return
      }
      this.$swal({
        text: 'Unknown Error Occured!',
        type: 'error'
      });
    },
    async rejectPlatform(item) {
      this.isLoading = true;
      let formData = new FormData()
      formData.append('platform', item.value)
      formData.append('influencerID', this.influencerID)
      await this.$store.dispatch('influencer/rejectPlatform', formData)
      this.isLoading = false;
      if (this.saved) {
        // Show success message
        let msg = `Successfully Rejected`
        this.$swal({
          text: msg,
          type: 'success'
        });
        this.resetEdit()
        this.$emit('reload')
        this.$emit('close')
        return
      }
      this.$swal({
        text: 'Unknown Error Occured!',
        type: 'error'
      });
    },
    async checkInf(handle, platform) {
      if (platform === 'tiktok') {
        await this.$store.dispatch('influencer/getInfluencerByTikTokHandle', {
          filters: {
            tiktokHandle: handle
          }
        })
      } else if (platform === 'youtube') {
        await this.$store.dispatch('influencer/getInfluencerByYoutubeHandle', {
          filters: {
            youtubeHandle: handle
          }
        })
      } else if (platform === 'xiaohongshu') {
        await this.$store.dispatch('influencer/getInfluencerByXHSHandle', {
          filters: {
            xhsHandle: handle
          }
        })
      } else if (platform === 'facebook') {
        await this.$store.dispatch('influencer/getInfluencerByFbHandle', {
          filters: {
            fbHandle: handle
          }
        })
      } else if (platform === 'linkedin') {
        await this.$store.dispatch('influencer/getInfluencerByLinkedInHandle', {
          filters: {
            linkedinHandle: handle
          }
        })
      } else if (platform === 'twitter') {
        await this.$store.dispatch('influencer/getInfluencerByTwitterHandle', {
          filters: { twitterHandle: handle }
        })
      } else {
        await this.$store.dispatch('influencer/getInfluencerByIgHandle', {
          filters: {
            instagramHandle: handle
          }
        })
      }
    },
    resetEdit() {
      this.filteredItems = this.resetEditFields(this.filteredItems, ['handle'])
      this.showEditActions = false
    },
    changeConnectState(item, state) {
      let itemIndex = this.filteredItems.indexOf(item)
      if (itemIndex !== -1) {
        this.filteredItems[itemIndex].connected = state
        if (state) this.filteredItems[itemIndex].requested = false
      }
    },
    buildFormData(items) {
      let savePlatforms = []
      items.map(item => {
        if (item.handle) {
          let handle = item.handle
          if (item.value === 'instagram') {
            handle = utils.func.espaceHandleSign(utils.func.regexMatchIg(handle, config.regexPattern.instagram_profile))
          } else if (item.value === 'tiktok') {
            handle = utils.func.espaceHandleSign(utils.func.extractTikTokHandle(handle))
          } else if (item.value === 'twitter') {
            handle = this.normalizeTwitterHandle(handle)
          }
          let matchItemIdx = this.filteredItems.findIndex(f => f.handle === item.handle)
          if (matchItemIdx !== -1) {
            this.filteredItems[matchItemIdx].handle = handle
          }
          savePlatforms.push({
            handle,
            platform: item.value
          })
        }
      })
      let formData = new FormData()
      formData.append('platforms', JSON.stringify(savePlatforms))
      formData.append('influencerID', this.influencerID)
      return formData
    },
    refreshItems() {
      this.filteredItems = Object.assign([], this.items)
      this.resetEdit()
      this.filteredItems = this.filteredItems.map(item => {
        if ((!item.connected && !item.handle) || item.requested) {
          item.handleEdit = true
        }
        return item
      })
      this.filteredItems = utils.func.refreshJSON(this.filteredItems)
    },
    normalizeTwitterHandle(value) {
      let handle = String(value || '').trim()
      const twitterUrl = handle.match(/^(?:https?:\/\/)?(?:www\.)?(?:x|twitter)\.com\/([^/?#]+)/i)
      if (twitterUrl) handle = twitterUrl[1]
      return handle.replace(/^@+/, '').replace(/\/+$/, '').trim()
    }
  }
}
</script>
<style scoped>
  .item-edit {
    min-width: 75px;
    min-height: 50px;
    padding-top: 15px;
  }
</style>



// WEBPACK FOOTER //
// DataTable.vue?f6929824